module.exports = __webpack_public_path__ + "static/media/sw-audiobook-sample.cf481422.mp3";